import React, {useRef} from "react"

import UsersToAdd from "../../users/model/collection"
import {AddUser_Manager} from "../../users/model/manager"
import {AddUserType} from "../../users/@const"
import UserToAdd from "../../users/model/add-user"
import {ProjectAccess} from "../../../gd/const/project"
import {ButtonType} from "../../../gd-components/buttons/gd-button/gd-button-ui5-new"
import {AddUser_createProjectUsers, AddUser_createWorkspaceUsers} from "../../users/actions/create-users"
import HelpBlock, {HelpType} from "../../../gd-components/help-and-hint/help-block/help-block"
import VScroll from "../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import Modal_addUsers from "./add-users"
import Modal_Submit from "../submit/submit"
import {MissingUsersManagerInterface} from "./missing-users-manager-interface"

type Props = {
    manager: MissingUsersManagerInterface
}

// const debug = "Modal_AddMissingUsers"
const debug = false

export default function Modal_AddMissingUsers(props: Props) {

    const refSubmitButton: any = useRef()

    const users             = props.manager.missingUsers
    const targetProject     = props.manager.targetProject
    const showProjectAccess = props.manager.showProjectAccess

    const defaultWorkspaceAccess  : ProjectAccess = ProjectAccess.STANDARD
    const defaultProjectAccess    : ProjectAccess = ProjectAccess.STANDARD

    const usersToAddToWorkspace = new UsersToAdd(new AddUser_Manager(AddUserType.WORKSPACE_USER))
    const usersToAddToProject = new UsersToAdd(new AddUser_Manager(AddUserType.WORKSPACE_USER))

    if (targetProject?.workspace) {
        _.map(users?.workspaceIds, (userId:ID)=>{
            const companyUser = gd.session.companyUsers.getByUserId(userId)
            if (companyUser) {
                const userToAdd = new UserToAdd(companyUser)
                userToAdd.workspaceAccess   = defaultWorkspaceAccess
                userToAdd.projectAccess     = defaultProjectAccess
                userToAdd.isSelected        = true
                usersToAddToWorkspace.add(userToAdd)
            }
        })
    }

    _.map(users?.projectIds, (userId:ID)=>{
        if (targetProject?.workspace && users?.workspaceIds.includes(userId)) {
            // skip
            return
        }

        const companyUser = gd.session.companyUsers.getByUserId(userId)
        if (companyUser) {
            const userToAdd             = new UserToAdd(companyUser)
            userToAdd.projectAccess     = defaultProjectAccess
            userToAdd.isSelected        = true
            usersToAddToProject.add(userToAdd)
        }
    })

    const onSubmit = async () => {
        debug && console.log(debug, 'onSubmit', usersToAddToWorkspace.available, usersToAddToProject.available)

        refSubmitButton.current.setType(ButtonType.BUSY)

        if (targetProject?.workspace && !usersToAddToWorkspace.isEmpty) {
            await AddUser_createWorkspaceUsers(targetProject?.workspace, usersToAddToWorkspace)

            // add project users only it is required
            if (showProjectAccess) {
                await AddUser_createProjectUsers(targetProject, usersToAddToWorkspace)
            }
        }

        if (!usersToAddToProject.isEmpty && targetProject) {
            await AddUser_createProjectUsers(targetProject, usersToAddToProject)
        }

        props.manager.commit()
    }

    debug && console.log(debug, 'render', usersToAddToWorkspace, usersToAddToProject)

    const length = usersToAddToWorkspace.length + usersToAddToProject.length
    const submitButtonLabel = length <= 1 ? "Add User & Move" : "Add Users & Move"

    const importantNotification = 'Some users are not present in the target {0}, and you need to add them.'.f(showProjectAccess ? 'workspace/project' : 'workspace')

    return (
        <>
            <div className="w-100-percent p-l-30 p-r-30 border-box">
                <HelpBlock type         = {HelpType.IMPORTANT}>
                    {importantNotification}
                </HelpBlock>
            </div>

            <VScroll className="central-container" containerClass="p-l-30 p-t-20 p-r-30">
                <Modal_addUsers targetProject         = {targetProject}
                                showProjectAccess     = {showProjectAccess}
                                showWorkspaceAccess   = {usersToAddToWorkspace.available.length > 0}
                                usersToAddToWorkspace = {usersToAddToWorkspace}
                                usersToAddToProject   = {usersToAddToProject}/>
            </VScroll>

            <Modal_Submit ref       = {refSubmitButton}
                          type      = {ButtonType.PRIMARY}
                          label     = {submitButtonLabel}
                          onSubmit  = {onSubmit}/>
        </>
    )
}